import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }


    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
        color: #343434 !important;
    }

    .menu a{
    float: left;
    display: flex
;
    -webkit-box-pack: center;
    flex-wrap: nowrap;
    align-items: center;
    height: 80px;
    justify-content: center;
    flex-direction: column;
    }
    .menu a.active span{
    color: #dc535a;
    text-underline-position: under;
    text-decoration: #dc535a wavy underline;
}
    .menu a span{
    display: flex;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
    }
    .menu a button{
    width: 100%;
    }
    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #fff;
        overflow-x: hidden;
    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: rgb(241, 242, 243);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        color: #2e2e2e;
        font-size: 42px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color:rgb(62, 62, 62);
        font-size: 18px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #2E186A;

        :hover {
            color: #2e186a;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
    .service-block{
        // border: solid 4px #f0f0f0;
        box-shadow: rgba(23, 31, 114, 0.2) 0px 16px 30px;
        margin: 30px 10px;
        padding: 10px 20px;
        border-radius: 10px;
        cursor: pointer;
    }
    .service-block:hover{
        box-shadow: rgba(23, 31, 114, 0.2) 0px 16px 30px;
        transform: scale(1.02);
        transition: all 0.3s ease-in-out;
        // background: #f0f0f0;
}
        .filterit{
        // filter: invert(12%) sepia(83%) saturate(5841%) hue-rotate(244deg) brightness(87%) contrast(153%);
        }
        .cta, .langs{
            margin-top: 50px;
            // margin-bottom: 50px;
            background-color: #f0f0f0;
            padding: 20px;
            border-radius: 5px;
            }
        .cta h2{
            margin-top: 10px;
            font-size: 30px;
            }
        .cta p{
            font-size: 18px;
            font-weight: 400;
        }
        .cta button{
            margin-top: 30px;
        }
        .langs .ant-col{
            display: flex;
            justify-content: space-around;
            align-items: center;
            overflow-x: auto;
        }
        .aboutfoot{
        margin-top: 20px;
        }
        .portfolio-image{
        width: 100%;
        height: 200px;
        overflow: hidden;
        }
        .portfolio-image img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: top;
            border-bottom: solid 1px #f0f0f0;
        }
        .portfolio-block{
        box-shadow: rgba(23, 31, 114, 0.2) 0px 16px 30px;
        margin: 30px 10px;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;
        }
        .portfolio-block:hover{
            box-shadow: rgba(23, 31, 114, 0.2) 0px 16px 30px;
            transform: scale(1.02);
            transition: all 0.3s ease-in-out;
            }
        .portfolio-block h3{
        font-size: 20px;
        margin-top: 20px;
        padding: 0px 15px;
        }
        .portfolio-block p{
            font-size: 14px;
margin: 10px 15px;
        }
        .tag{
            padding: 5px 10px;
  margin: 2px 0px 2px 2px;
  border-radius: 50px;
  background: rgb(67, 172, 247);
  color: rgb(255, 255, 255);
  font-size: 12px;
  white-space: nowrap;
  float: left;
        }
        .tags{
            position: relative;
            bottom: 0px;
            margin: 0px 0px 10px 10px;
            float: left;
        }
        .description{
    font-size: 14px;
            color: #2e2e2e;
            margin-top: 10px;
        }
        .popup{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
top: 0;
    left: 0;
    z-index: 999;
        }
    .home-banner{
position: relative;
    width: 60%;
    min-width: 300px;
    height: auto;
    // min-height: 200px;
    overflow: auto;
    margin: auto;
    top: 70px;
    background: #fff;
}
    .d-none{
        display: none !important;}
    @media only screen and (max-width: 890px) {
width: 90%;
        height: auto;
        top: 30px;
        left: 5%;
        margin: 0;
    }
    .home-banner img{
        position: relative;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        object-fit: cover;
        object-position: top;
    }
    .home-banner .ant-col{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home-banner .ant-col img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
    .home-banner .ant-col h1{
        position: absolute;
        top: 50%;
        left: 50%;
    }
        

        .close-popup{
        position: absolute;
  z-index: 1;
  right: 0px;
  float: right;
  background: #d23131;
  border: none;
  border-radius: 60px;
  width: 30px;
  height: 30px;
  color: #fff;
  font-size: 18px;
  padding: 0px;
}
`;
